<div class="generic-modal-header">
  <h2 mat-dialog-title class="generic-modal-title">{{ titleAlreadyLocalized ? title : (title | localize) }}</h2>
  <app-close-btn-modal (click)="onCancel()"></app-close-btn-modal>
</div>

<div class="generic-modal-body">
  <ng-content></ng-content>
</div>

<mat-dialog-actions *ngIf="showFooter" align="end" class="generic-modal-footer">
  <ng-content select="[modalFooterExtra]"></ng-content>
  <button
    *ngIf="showCancelButton"
    mat-stroked-button
    type="button"
    (click)="onCancel()"
  >{{ cancelLabel | localize }}</button>
  <app-submit-button
    *ngIf="showSaveButton"
    [title]="saveLabel"
    [saving]="saving"
    [disabled]="saveDisabled"
    [type]="saveType"
    (click)="onSave()"
  ></app-submit-button>
</mat-dialog-actions>
